import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { theme } from '../design/theme';

export const EnterpriseLayout: React.FC = () => {
  const menuItems = [
    { label: 'Dashboard', path: '/enterprise/dashboard', icon: '📈' },
    { label: 'Employees', path: '/enterprise/users', icon: '👥' },
    { label: 'Token Consumption', path: '/enterprise/consumption', icon: '🎫' },
    { label: 'Budget Usage', path: '/enterprise/budget', icon: '💰' },
    { label: 'AI Orchestration', path: '/enterprise/ai-orchestration', icon: '🤖' },
    { label: 'Profile', path: '/enterprise/profile', icon: '👤' },
  ];

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: theme.colors.background.muted }}>
      <Sidebar items={menuItems} title="Enterprise" />
      <main style={{ 
        flex: 1, 
        paddingLeft: 'var(--sidebar-width, 280px)',
        transition: 'padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        width: '100%'
      }}>
        <div style={{ 
          maxWidth: theme.layout.maxWidth, 
          margin: '0 auto',
          padding: theme.spacing.xl,
          width: '100%'
        }}>
          <Outlet />
        </div>
      </main>
    </div>
  );
};
